import { render } from "./medicineDigitalTravel.vue?vue&type=template&id=1c96e421&scoped=true"
import script from "./medicineDigitalTravel.vue?vue&type=script&lang=js"
export * from "./medicineDigitalTravel.vue?vue&type=script&lang=js"

import "./medicineDigitalTravel.vue?vue&type=style&index=0&id=1c96e421&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c96e421"

export default script